import { IconButton } from "@material-ui/core"
import { useDispatch } from "react-redux"
import BeenhereIcon from '@material-ui/icons/Beenhere'
import { validarDevolucionAction, obtenerDevolucionesPendientesAction } from "../../../ducks/devolucionesDuck"
import { ToastMessage } from "../../../global/ToastMessage"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { DialogMessage } from "../../../global/DialogMessage"
const ButtonAceptarDevolucion = (props) => {
    const { IdDevolucionSolicitud } = props
    const dispatch = useDispatch()
    const handleClick = () => {
        DialogMessage.fire({
            title: `¿Está seguro de enviar esta devolucion?`,
            text: 'Se mandara al area de finanzas',
            showCancelButton: true,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(validarDevolucionAction({ IdDevolucionSolicitud: IdDevolucionSolicitud })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status || Response?.status === 500) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                        });
                        return null
                    }
                    if (Response.status || Response?.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                        });
                        return null
                    }
                    dispatch(obtenerDevolucionesPendientesAction())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
       
    }
    return (
        <div>
            <IconButton aria-label="Descargar" onClick={handleClick} color="secondary" >
                <BeenhereIcon />
            </IconButton>
        </div>
    )
}
export default ButtonAceptarDevolucion